export default __webpack_public_path__ + "static/media/shield-icon.0d127dff.svg";